import { Component, Input } from '@angular/core';
import { OrderCatalogDataService } from '../../main/order/catalog/order-catalog-data.service';

@Component({
  selector: 'favourite-toggle',
  template: `
    <a (click)="toggleAction()" class="favourite" href="">
      <i class="fa" [ngClass]="isFavourite ? 'fa-star' : 'fa-star-o'"></i>
      <ng-content></ng-content>
    </a>
  `,
  providers: [
    OrderCatalogDataService
  ]
})
export class FavouriteToggleComponent {
  @Input('productId') public productId:number;
  @Input('isFavourite') public isFavourite:boolean;

  constructor(
    private orderCatalogDataService:OrderCatalogDataService
  ) {
    /***/
  }

  public toggleAction():boolean {
    this.isFavourite = !this.isFavourite;
    this.orderCatalogDataService.toggleFavourite(this.productId, this.isFavourite)
      .catch(() => {
        // revert
        this.isFavourite = !this.isFavourite;
      });
    return false;
  }
}